// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-am-inputtext] textarea.text-description {
  height: 16rem;
  font-size: max(16px, 1rem);
}
`, "",{"version":3,"sources":["webpack://./src/components/Description/Description.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;AAC5B","sourcesContent":["[data-am-inputtext] textarea.text-description {\r\n  height: 16rem;\r\n  font-size: max(16px, 1rem);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
